import DatetimeUtils from "../../../../gd/utils/datetime-utils";


export default class TodoProperties {

    public title        : string
    public completed    : boolean
    public messageId    : ID | null
    public userId       : ID | null
    public deadline     : Moment
    public description  : string

    constructor(rawData:any) {
        this.title          = _.get(rawData, 'title', '')
        this.completed      = _.get(rawData, 'completed', false)
        this.messageId      = _.get(rawData, 'messageId', null) // for item from message
        this.userId         = _.get(rawData, 'userId', null) // assigned userId
        this.description    = _.get(rawData, 'description', null)

        this.deadline       = DatetimeUtils.datetimeToMoment(_.get(rawData,'deadline',null))
    }

    isCompleted = ()=> this.completed
    getName = () => this.title
    setName(value:string) {this.title = value}
    setStatus(value:boolean) {this.completed = value}
    setUser(value:ID) {this.userId = value}
    setDescription(value: string) {this.description = value}
    setDeadline(value: Moment) {this.deadline = value}

    toJSON() {
        return {
            title       : this.title,
            completed   : this.completed,
            messageId   : this.messageId,
            userId      : this.userId,
            description : this.description,
            deadline    : !!this.deadline ? this.deadline.toJSON() : null
        }
    }
}
